export default __webpack_public_path__ + "echo_devices.eb742545.png";